import { type Waypoint } from '@/app/services/solution/types/get-waypoint';

const waypoints: Waypoint[] = [
  {
    id: 1,
    name: 'Stockholm',
    vehiclesAtLocation: 3,
    type: 'Depot',
    peakPowerNeed: 700,
    powerLimit: 644,
    vehiclesCharging: 2,
    energyConsumption: 1445,
    maxCapacity: 600,
    futureMaxCapacity: 800,
    h3CellIndex: '8b088661e352fff',
    baseDemandType: 'manual',
    constantBaseDemand: 0,
    manualBaseDemandProfile: [500, 700, 350, 800, 700, 490],
  },
  {
    id: 2,
    name: 'Uppsala',
    vehiclesAtLocation: 1,
    type: 'Waypoint',
    peakPowerNeed: 700,
    powerLimit: 644,
    vehiclesCharging: 1,
    energyConsumption: 1445,
    maxCapacity: 300,
    futureMaxCapacity: 350,
    h3CellIndex: '890880d9d73ffff',
    baseDemandType: 'constant',
    constantBaseDemand: 0,
    manualBaseDemandProfile: [0, 0, 0, 0, 0, 0],
  },
  {
    id: 3,
    name: 'Järfälla',
    vehiclesAtLocation: 5,
    type: 'Depot',
    peakPowerNeed: 700,
    powerLimit: 644,
    vehiclesCharging: 2,
    energyConsumption: 1445,
    maxCapacity: 200,
    futureMaxCapacity: 300,
    h3CellIndex: '8908867464fffff',
    baseDemandType: 'constant',
    constantBaseDemand: 0,
    manualBaseDemandProfile: [200, 100, 350, 400, 300, 490],
  },
  {
    id: 4,
    name: 'Södertälje',
    vehiclesAtLocation: 5,
    type: 'Depot',
    peakPowerNeed: 700,
    powerLimit: 644,
    vehiclesCharging: 2,
    energyConsumption: 1445,
    maxCapacity: 300,
    futureMaxCapacity: 400,
    h3CellIndex: '8d088645e974abf',
    baseDemandType: 'constant',
    constantBaseDemand: 0,
    manualBaseDemandProfile: [0, 0, 0, 0, 0, 0],
  },
  {
    id: 5,
    name: 'Färingsö',
    vehiclesAtLocation: 1,
    type: 'Waypoint',
    peakPowerNeed: 700,
    powerLimit: 644,
    vehiclesCharging: 1,
    energyConsumption: 1445,
    maxCapacity: 230,
    futureMaxCapacity: 200,
    h3CellIndex: '8a088672aa57fff',
    baseDemandType: 'manual',
    constantBaseDemand: 0,
    manualBaseDemandProfile: [240, 120, 250, 300, 200, 290],
  },
  {
    id: 6,
    name: 'Västerås',
    vehiclesAtLocation: 5,
    type: 'Depot',
    peakPowerNeed: 700,
    powerLimit: 644,
    vehiclesCharging: 2,
    energyConsumption: 1445,
    maxCapacity: 400,
    futureMaxCapacity: 500,
    h3CellIndex: '8a088695942ffff',
    baseDemandType: 'constant',
    constantBaseDemand: 0,
    manualBaseDemandProfile: [0, 0, 0, 0, 0, 0],
  },
  {
    id: 7,
    name: 'Eskilstuna',
    vehiclesAtLocation: 5,
    type: 'Depot',
    peakPowerNeed: 700,
    powerLimit: 644,
    vehiclesCharging: 2,
    energyConsumption: 1445,
    maxCapacity: 200,
    futureMaxCapacity: 300,
    h3CellIndex: '8a088699ec6ffff',
    baseDemandType: 'constant',
    constantBaseDemand: 0,
    manualBaseDemandProfile: [0, 0, 0, 0, 0, 0],
  },
  {
    id: 8,
    name: 'Enköping',
    vehiclesAtLocation: 5,
    type: 'Depot',
    peakPowerNeed: 700,
    powerLimit: 644,
    vehiclesCharging: 2,
    energyConsumption: 1445,
    maxCapacity: 350,
    futureMaxCapacity: 450,
    h3CellIndex: '8a0886b9d39ffff',
    baseDemandType: 'constant',
    constantBaseDemand: 0,
    manualBaseDemandProfile: [0, 0, 0, 0, 0, 0],
  },
  {
    id: 9,
    name: 'Skogstorp',
    vehiclesAtLocation: 3,
    type: 'Depot',
    peakPowerNeed: 700,
    powerLimit: 644,
    vehiclesCharging: 2,
    energyConsumption: 1445,
    maxCapacity: 600,
    futureMaxCapacity: 800,
    h3CellIndex: '8d0886d61c687bf',
    baseDemandType: 'manual',
    constantBaseDemand: 0,
    manualBaseDemandProfile: [500, 700, 350, 800, 700, 490],
  },
  {
    id: 10,
    name: 'Hälleforsnäs',
    vehiclesAtLocation: 3,
    type: 'Depot',
    peakPowerNeed: 700,
    powerLimit: 644,
    vehiclesCharging: 2,
    energyConsumption: 1445,
    maxCapacity: 600,
    futureMaxCapacity: 800,
    h3CellIndex: '8d0886d13a73a3f',
    baseDemandType: 'manual',
    constantBaseDemand: 0,
    manualBaseDemandProfile: [500, 700, 350, 800, 700, 490],
  },
];

export default waypoints;
